module.exports = __webpack_public_path__ + "static/media/PoppinsRegular.d0194368.ttf";